import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    questionText: {
        textAlign: "center",
    },
}));

type AnswerProps = {
    question: string;
}

export default function QuestionPlay({ question }: AnswerProps): JSX.Element {

    const classes = useStyles();
    return (
        <Typography variant="h5" className={classes.questionText}>
            {question}
        </Typography>
    );
}
